import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
} from '../actions/AuthActions';

const initialState = {
    auth: {
        email: '',
        idToken: '',
        localId: '',
        expiresIn: '',
        refreshToken: '',
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    if (action.type === SIGNUP_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Signup Successfully Completed',
            showLoading: false,
        };
    }
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        console.log('🟢 [AuthReducer] LOGIN_CONFIRMED_ACTION received, payload:', action.payload);
        // Map access_token to idToken for compatibility
        const authData = {
            ...action.payload,
            idToken: action.payload.access_token || action.payload.idToken || '',
            email: action.payload.email || '',
        };
        console.log('🟢 [AuthReducer] Mapped authData:', { 
            idToken: authData.idToken ? 'present' : 'missing',
            access_token: authData.access_token ? 'present' : 'missing',
            email: authData.email 
        });
        const newState = {
            ...state,
            auth: authData,
            errorMessage: '',
            successMessage: 'Login Successfully Completed',
            showLoading: false,
        };
        console.log('🟢 [AuthReducer] New state after login:', { 
            idToken: newState.auth.idToken ? 'present' : 'missing',
            access_token: newState.auth.access_token ? 'present' : 'missing'
        });
        return newState;
    }

    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {
                email: '',
                idToken: '',
                localId: '',
                expiresIn: '',
                refreshToken: '',
            },
        };
    }

    if (
        action.type === SIGNUP_FAILED_ACTION ||
        action.type === LOGIN_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }

    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    return state;
}

    
